export const initialState = {
    name: '',
};

export const regionsAndLocationsPath = '/regions-and-locations';

export const breadCrumbTrail = [
    { label: 'Admin', path: '' },
    { label: 'Regions and Locations', path: regionsAndLocationsPath },
    { label: 'Add Region', path: '' },
];

export const breadCrumbTrailEdit = [
    { label: 'Admin', path: '' },
    { label: 'Regions and Locations', path: regionsAndLocationsPath },
    { label: 'Edit Region', path: '' },
];

export const addHeader = 'Region Details';
export const editHeader = 'Edit Region Details';

export const ERROR_MESSAGES = {
    NAME_REQUIRED: 'Field is required.',
};
